import React from 'react'
import { usePaginationFragment, useFragment, graphql } from 'react-relay'

import { useMedia } from 'tamagui'

import { EventList } from '@newComponents'

import { UserEventsUpcomingSection_user$key } from './__generated__/UserEventsUpcomingSection_user.graphql'
import { UserEventsUpcomingSection_query$key } from './__generated__/UserEventsUpcomingSection_query.graphql'

export const UserEventsUpcomingSection = ({
  user,
  query,
}: {
  user: UserEventsUpcomingSection_user$key
  query: UserEventsUpcomingSection_query$key
}) => {
  const { data, hasNext, loadNext } = usePaginationFragment(
    graphql`
      fragment UserEventsUpcomingSection_user on User
      @refetchable(queryName: "UserEventsUpcomingSectionPaginationQuery")
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        upcomingEvents: eventAttendance(
          first: $count
          after: $cursor
          timeSelection: UPCOMING
        ) @connection(key: "UserEventsUpcomingSection_user_upcomingEvents") {
          edges {
            cursor
          }

          ...EventList_eventsConnection
        }
      }
    `,
    user
  )

  const queryData = useFragment(
    graphql`
      fragment UserEventsUpcomingSection_query on Query {
        ...EventList_query
      }
    `,
    query
  )

  const media = useMedia()

  return (
    <EventList
      eventsConnection={data.upcomingEvents}
      query={queryData}
      hasNext={hasNext}
      loadNext={loadNext}
      forceVertical={media.md}
    />
  )
}
